import { collectionProductsRouting } from "@/frontend/algolia/search-results/lib/routing";
import { InstantSearch, Configure } from "react-instantsearch";
import { searchClient, searchIndexes } from "@/frontend/algolia/search-shared/client";
import { VirtualSearchBox } from "@/frontend/algolia/search-shared/VirtualSearchBox";
import { VirtualFilters } from "@/frontend/algolia/search-shared/VirtualFilters";
import { ScrollTo } from "@/frontend/algolia/search-results/components/ScrollTo";

import ProductList from "../components/ProductList";

function AlgoliaCollectionList({ collectionHandle }: { collectionHandle: string }) {
  const { collections_full_results_hits_per_page = 42 } = window.algoliaShopify?.config || {};

  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={searchIndexes.RECOMMENDED_PRODUCTS}
      insights={true}
      routing={collectionProductsRouting}
      future={{ preserveSharedStateOnUnmount: true }}
    >
      <Configure
        hitsPerPage={collections_full_results_hits_per_page}
        filters={`collections:${collectionHandle}`}
      />

      <VirtualSearchBox />
      <VirtualFilters />

      <ScrollTo>
        <ProductList hitsPerPage={collections_full_results_hits_per_page} usePromo={true} />
      </ScrollTo>
    </InstantSearch>
  );
}

export default AlgoliaCollectionList;
